<div id="descubre-nuestros-productos" class="py-5 px-2 px-lg-5 bg-primary-50">
    <div class="container">
        <div class="row">
            <div class="col-12 mx-auto text-center">
                <p class="tab-ancla primary-500 mb-2">DESCUBRE NUESTROS PRODUCTOS</p>
                <h1 class="primary-900 mb-3">Ahorra · Invierte · Rentabiliza con<br class="d-none d-sm-block"> SEGOFINANCE</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-8 mx-auto text-center">
                <p class="primary-900 p1-regular mb-4">Descubre nuestros <strong class="p1-bold">productos de inversión</strong> e invierte
                    con nosotros para construir una <strong class="p1-bold">cartera diversificada</strong>
                    desde una <strong class="p1-bold">compañía de inversión alternativa</strong>.</p>
                <a routerLink="/quienes-somos"
                    class="link1-bold primary-900 d-flex align-items-center justify-content-center"
                    title="Descúbrenos, somos diferentes">
                    <span class="me-1">Descúbrenos, somos diferentes</span>
                    <span class="material-symbols-outlined">arrow_forward</span>
                </a>
            </div>
        </div>
        <div class="row mt-4 px-4 px-lg-0 justify-content-center">
            <div class="col-lg-3 text-center">
                <div class="my-3">
                    <img class="mat-icon-size-50" src="assets/images/home/descubre_productos_1.svg"
                        title="Primera plataforma participativa" alt="Primera plataforma participativa">
                </div>
                <p class="primary-800 mb-0"><strong class="p1-bold">Primera plataforma <br>participativa</strong></p>
            </div>
            <div class="col-lg-3 text-center">
                <div class="my-3">
                    <img class="mat-icon-size-50" src="assets/images/home/descubre_productos_2.svg"
                        title="Con más de 12 años de experiencia" alt="Con más de 12 años de experiencia">
                </div>
                <p class="primary-800 mb-0"><strong class="p1-bold">Con más de 12 años <br>de experiencia</strong></p>
            </div>
            <div class="col-lg-3 text-center">
                <div class="my-3">
                    <img class="mat-icon-size-50" src="assets/images/home/descubre_productos_4.svg"
                        title="La revolución de la Banca Privada" alt="La revolución de la Banca Privada">
                </div>
                <p class="primary-800 mb-0"><strong class="p1-bold">La revolución de <br>la Banca Privada</strong></p>
            </div>
        </div>
    </div>
</div>